<template>
    <div v-if="status.detail">
        <dl class="row mb-0">
            <dt class="col-sm-4">{{ $t('label.agenda') }}</dt>
            <dd class="col-sm-8">{{ details.agenda || '-' }}</dd>
            <dt class="col-sm-4">{{ $t('module.meetingRoom') }}</dt>
            <dd class="col-sm-8">{{ details.meetingRoomName || '-' }}</dd>
            <dt class="col-sm-4">{{ $t('label.company') }}</dt>
            <dd class="col-sm-8"><CompanyLink :uuid="details.companyUUID" :name="details.companyName" /></dd>
            <dt class="col-sm-4">{{ $t('label.office') }}</dt>
            <dd class="col-sm-8">{{ details.officeName || '-' }}</dd>
            <dt class="col-sm-4">{{ $t('label.meetingStart') }}</dt>
            <dd class="col-sm-8">{{ details.startDisplay || '-' }}</dd>
            <dt class="col-sm-4">{{ $t('label.meetingEnd') }}</dt>
            <dd class="col-sm-8">{{ details.endDisplay || '-' }}</dd>
            <dt class="col-sm-4">{{ $t('label.status') }}</dt>
            <dd class="col-sm-8"><b-badge :variant="details.isActive ? 'success' : 'secondary'">{{ $t(details.isActive ?
                'label.active' : 'label.inactive') }}</b-badge></dd>
            <dt class="col-sm-4">{{ $t('label.description') }}</dt>
            <dd class="col-sm-8">{{ details.description || '-' }}</dd>
        </dl>
        <h6 class="mt-3">{{ $t('label.attendees') }}</h6>
        <ul v-if="details.attendees.length" class="mb-0">
            <li v-for="attendee in details.attendees" :key="attendee.uuid">{{ attendeeName(attendee) }}</li>
        </ul><span v-else>-</span>
    </div>
    <div v-else class="text-center p-5"><b-spinner variant="info" /></div>
</template>
<script>
import { mapState } from 'vuex';
import { meetingRoomBookingMethods } from '@/state/api';
import { MEETING_ROOM_BOOKING_MODULE } from '@/state/api/meetingRoomBooking.state';

export default {
    name: 'MeetingRoomBookingDetail',
    props: { bookingUUID: { type: String, required: true } },
    computed: {
        ...mapState(MEETING_ROOM_BOOKING_MODULE, ['status']),
        details() {
            return this.$store.state.api.meetingRoomBooking.details || { attendees: [] };
        }
    },
    created() {
        this.getMeetingRoomBooking({ uuid: this.bookingUUID });
    },
    methods: {
        ...meetingRoomBookingMethods,
        attendeeName(item) {
            const user = item.user || {};
            return ([user.first_name, user.last_name].filter(Boolean).join(' ') || item.email || '-') + (user.email ? " ( " + user.email + " )" : "");
        }
    }
};
</script>
